import axios from "axios";

const getAddress = async (lat: number, lng: number) => {
  return await axios.get(`https://nominatim.openstreetmap.org/reverse`, {
    params: {
      lat: lat,
      lon: lng,
      format: "json",
      "accept-language": "fa", // Request Farsi language
    },
  });
};

const geoService = {
  getAddress,
};

export default geoService;
